// Invoice.js
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import logo from "../../image/heycourierLogo.png";

const AdjustmentInvoicePdf = forwardRef(({ data }, ref) => {
  if (!data) return null;

  return (
    <div
      ref={ref}
      style={{
        padding: "20px",
        background: "white",
        maxWidth: "800px",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
        wordWrap: "break-word",
      }}
    >
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          //   alignItems: "flex-start",
          flexWrap: "wrap",
        }}
      >
        <div>
          <img src={logo} alt="Hey Couriers Logo" style={{ height: "60px" }} />
        </div>
        <div
          style={{
            textAlign: "right",
            fontSize: "14px",
            wordBreak: "break-word",
            maxWidth: "100%",
          }}
        >
          <strong>THE BIG BOX GROUP PTY LTD T/A HEY COURIERS PTY LTD</strong>
          <br />
          <strong>ABN:</strong> {data.billed_by_abn}
          <br />
          {data.billed_by_email}
        </div>
      </div>

      {/* Invoice Metadata */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "30px",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <strong>Invoice Number</strong>
          <br />
          <div
            style={{
              border: "1px solid #ccc",
              padding: "5px 10px",
              minWidth: "150px",
              maxWidth: "250px",
              wordBreak: "break-word",
            }}
          >
            {data.invoice_number}
          </div>
        </div>
        <div>
          <strong>Invoice Date</strong>
          <br />
          <div
            style={{
              border: "1px solid #ccc",
              padding: "5px 10px",
              minWidth: "150px",
              maxWidth: "250px",
              wordBreak: "break-word",
            }}
          >
            {data.invoice_date}
          </div>
        </div>
      </div>
      {/* Type (Credit/Debit) */}
      <div style={{ marginTop: "20px", textAlign: "right" }}>
        <strong>Type:</strong>{" "}
        {data.type
          ? data.type.charAt(0).toUpperCase() + data.type.slice(1).toLowerCase()
          : ""}
      </div>
      {/* From and To Info */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "30px",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            flex: "1 1 48%",
            border: "1px solid #eee",
            padding: "10px",
            backgroundColor: "#fafafa",
            minWidth: "280px",
          }}
        >
          <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px" }}>
            <strong>Invoice From</strong>
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              wordBreak: "break-word",
            }}
          >
            {data.billed_by_legal_name}
            <br />
            {data.billed_by_business_name}
            <br />
            {data.billed_by_address}
            <br />
            <strong>ABN:</strong> {data.billed_by_abn}
          </div>
        </div>

        <div
          style={{
            flex: "1 1 48%",
            border: "1px solid #eee",
            padding: "10px",
            backgroundColor: "#fafafa",
            minWidth: "280px",
          }}
        >
          <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px" }}>
            <strong>Invoice To</strong>
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              wordBreak: "break-word",
            }}
          >
            {data.invoice_to_name}
            <br />
            {data.invoice_to_address_line.split(",").map((line, i) => (
              <span key={i}>
                {line.trim()}
                <br />
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Table for Note and Amount */}
      <table
        style={{
          width: "100%",
          marginTop: "30px",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
        border="1"
      >
        <thead style={{ backgroundColor: "#f2f2f2" }}>
          <tr>
            <th style={{ padding: "10px" }}>Note</th>
            <th style={{ padding: "10px" }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: "10px", wordBreak: "break-word" }}>
              {data.note}
            </td>
            <td style={{ padding: "10px" }}> ${data.adjustment_amount}</td>
          </tr>
        </tbody>
      </table>

      {/* Total Recharge */}
      <div style={{ textAlign: "right", marginTop: "20px", fontSize: "14px" }}>
        <strong>Total Adjustment:</strong> ${data.adjustment_amount}
      </div>

      {/* Bank Info */}
      <div
        style={{ marginTop: "40px", fontSize: "14px", wordBreak: "break-word" }}
      >
        <strong>BANK INFO</strong>
        <br />
        <strong>THE BIG BOX GROUP PTY LTD</strong>
        <br />
        Account No: {data.account_no}
        <br />
        BSB: {data.bank_state_branch}
      </div>

      {/* Thank You */}
      <div
        style={{
          textAlign: "right",
          marginTop: "30px",
          fontWeight: "bold",
          fontSize: "16px",
          color: "orange",
        }}
      >
        Thank You!
      </div>
    </div>
  );
});

AdjustmentInvoicePdf.propTypes = {
  data: PropTypes.shape({
    billed_by_legal_name: PropTypes.string,
    billed_by_business_name: PropTypes.string,
    billed_by_address: PropTypes.string,
    billed_by_abn: PropTypes.string,
    billed_by_email: PropTypes.string,
    invoice_to_name: PropTypes.string,
    invoice_to_address_line: PropTypes.string,
    invoice_number: PropTypes.string,
    invoice_date: PropTypes.string,
    note: PropTypes.string,
    recharge_amount: PropTypes.string,
    adjustment_amount: PropTypes.string,
    account_no: PropTypes.string,
    bank_state_branch: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
};

AdjustmentInvoicePdf.displayName = "AdjustmentInvoicePdf";
export default AdjustmentInvoicePdf;
